/**
 * @generated SignedSource<<0f5f5eab936201e14f100fb41649e179>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductRequiredFieldEnum = "customer_info" | "delivery_info" | "student_info" | "%future added value";
export type ProductShowTypeEnum = "non_registered" | "private" | "repurchase" | "store" | "upgrade" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductUpdateDialog_product$data = {
  readonly additionalDiscountAmount: number;
  readonly discountPrice: number;
  readonly id: string;
  readonly price: number;
  readonly requiredFields: ReadonlyArray<ProductRequiredFieldEnum>;
  readonly showTypes: ReadonlyArray<ProductShowTypeEnum>;
  readonly storeStuff: {
    readonly id: string;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "ProductUpdateDialog_product";
};
export type ProductUpdateDialog_product$key = {
  readonly " $data"?: ProductUpdateDialog_product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductUpdateDialog_product">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductUpdateDialog_product",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreStuff",
      "kind": "LinkedField",
      "name": "storeStuff",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showTypes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiredFields",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discountPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalDiscountAmount",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "c46527e78a9f94e795572126694714a6";

export default node;
